import { ATTESTATIONS, GraduationServicePath, MONTHLY_INTERNSHIP } from "utils/constants";
import permissions from "app/permissions";
import ListMonthlyInternshipAttestations from "./List";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + MONTHLY_INTERNSHIP + "/" + ATTESTATIONS + "/:id",
  title: "Заверки за месечен стаж",
  list: <ListMonthlyInternshipAttestations />,
  permission: permissions.canPreviewMonthlyInternshipAttestations,
};
